/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ExternalRouteImport } from './routes/external'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppKnowledgeRouteImport } from './routes/_app/knowledge'
import { Route as AppModulesRouteImport } from './routes/_app/modules'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppStudioRouteImport } from './routes/_app/studio'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppApprovalRequestsRequestIdRouteImport } from './routes/_app/approval-requests/$requestId'
import { Route as AppApprovalsIndexRouteImport } from './routes/_app/approvals/index'
import { Route as AppApprovalsApprovalIdRouteImport } from './routes/_app/approvals/$approvalId'
import { Route as AppCasesIndexRouteImport } from './routes/_app/cases/index'
import { Route as AppCasesCaseIdRouteImport } from './routes/_app/cases/$caseId'
import { Route as AppRegistryIndexRouteImport } from './routes/_app/registry/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings.index'
import { Route as AppSettingsModelsRouteImport } from './routes/_app/settings.models'
import { Route as AppStudioIndexRouteImport } from './routes/_app/studio/index'
import { Route as AppStudioNewRouteImport } from './routes/_app/studio/new'
import { Route as AppTasksIndexRouteImport } from './routes/_app/tasks/index'
import { Route as AppTasksTaskIdRouteImport } from './routes/_app/tasks/$taskId'
import { Route as AppRegistryAgentsNameRouteImport } from './routes/_app/registry/agents.$name'
import { Route as AppXPluginIdSplatRouteImport } from './routes/_app/x/$pluginId/$'
import { Route as AppStudioBundlesBundleIdVersionsVersionIndexRouteImport } from './routes/_app/studio/bundles.$bundleId.versions.$version.index'
import { Route as AppStudioBundlesBundleIdVersionsVersionPublishRouteImport } from './routes/_app/studio/bundles.$bundleId.versions.$version.publish'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ExternalRoute = ExternalRouteImport.update({
  id: '/external',
  path: '/external',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeRoute = AppKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => AppRoute,
} as any)
const AppModulesRoute = AppModulesRouteImport.update({
  id: '/modules',
  path: '/modules',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppStudioRoute = AppStudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalRequestsRequestIdRoute =
  AppApprovalRequestsRequestIdRouteImport.update({
    id: '/approval-requests/$requestId',
    path: '/approval-requests/$requestId',
    getParentRoute: () => AppRoute,
  } as any)
const AppApprovalsIndexRoute = AppApprovalsIndexRouteImport.update({
  id: '/approvals/',
  path: '/approvals/',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsApprovalIdRoute = AppApprovalsApprovalIdRouteImport.update({
  id: '/approvals/$approvalId',
  path: '/approvals/$approvalId',
  getParentRoute: () => AppRoute,
} as any)
const AppCasesIndexRoute = AppCasesIndexRouteImport.update({
  id: '/cases/',
  path: '/cases/',
  getParentRoute: () => AppRoute,
} as any)
const AppCasesCaseIdRoute = AppCasesCaseIdRouteImport.update({
  id: '/cases/$caseId',
  path: '/cases/$caseId',
  getParentRoute: () => AppRoute,
} as any)
const AppRegistryIndexRoute = AppRegistryIndexRouteImport.update({
  id: '/registry/',
  path: '/registry/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsModelsRoute = AppSettingsModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppStudioIndexRoute = AppStudioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStudioRoute,
} as any)
const AppStudioNewRoute = AppStudioNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppStudioRoute,
} as any)
const AppTasksIndexRoute = AppTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksTaskIdRoute = AppTasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => AppRoute,
} as any)
const AppRegistryAgentsNameRoute = AppRegistryAgentsNameRouteImport.update({
  id: '/registry/agents/$name',
  path: '/registry/agents/$name',
  getParentRoute: () => AppRoute,
} as any)
const AppXPluginIdSplatRoute = AppXPluginIdSplatRouteImport.update({
  id: '/x/$pluginId/$',
  path: '/x/$pluginId/$',
  getParentRoute: () => AppRoute,
} as any)
const AppStudioBundlesBundleIdVersionsVersionIndexRoute =
  AppStudioBundlesBundleIdVersionsVersionIndexRouteImport.update({
    id: '/bundles/$bundleId/versions/$version/',
    path: '/bundles/$bundleId/versions/$version/',
    getParentRoute: () => AppStudioRoute,
  } as any)
const AppStudioBundlesBundleIdVersionsVersionPublishRoute =
  AppStudioBundlesBundleIdVersionsVersionPublishRouteImport.update({
    id: '/bundles/$bundleId/versions/$version/publish',
    path: '/bundles/$bundleId/versions/$version/publish',
    getParentRoute: () => AppStudioRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/external': typeof ExternalRoute
  '/login': typeof LoginRoute
  '/admin': typeof AppAdminRoute
  '/knowledge': typeof AppKnowledgeRoute
  '/modules': typeof AppModulesRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/studio': typeof AppStudioRouteWithChildren
  '/users': typeof AppUsersRoute
  '/approval-requests/$requestId': typeof AppApprovalRequestsRequestIdRoute
  '/approvals/$approvalId': typeof AppApprovalsApprovalIdRoute
  '/cases/$caseId': typeof AppCasesCaseIdRoute
  '/settings/models': typeof AppSettingsModelsRoute
  '/studio/new': typeof AppStudioNewRoute
  '/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/approvals/': typeof AppApprovalsIndexRoute
  '/cases/': typeof AppCasesIndexRoute
  '/registry/': typeof AppRegistryIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/studio/': typeof AppStudioIndexRoute
  '/tasks/': typeof AppTasksIndexRoute
  '/registry/agents/$name': typeof AppRegistryAgentsNameRoute
  '/x/$pluginId/$': typeof AppXPluginIdSplatRoute
  '/studio/bundles/$bundleId/versions/$version/publish': typeof AppStudioBundlesBundleIdVersionsVersionPublishRoute
  '/studio/bundles/$bundleId/versions/$version/': typeof AppStudioBundlesBundleIdVersionsVersionIndexRoute
}
export interface FileRoutesByTo {
  '/external': typeof ExternalRoute
  '/login': typeof LoginRoute
  '/admin': typeof AppAdminRoute
  '/knowledge': typeof AppKnowledgeRoute
  '/modules': typeof AppModulesRoute
  '/users': typeof AppUsersRoute
  '/': typeof AppIndexRoute
  '/approval-requests/$requestId': typeof AppApprovalRequestsRequestIdRoute
  '/approvals/$approvalId': typeof AppApprovalsApprovalIdRoute
  '/cases/$caseId': typeof AppCasesCaseIdRoute
  '/settings/models': typeof AppSettingsModelsRoute
  '/studio/new': typeof AppStudioNewRoute
  '/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/approvals': typeof AppApprovalsIndexRoute
  '/cases': typeof AppCasesIndexRoute
  '/registry': typeof AppRegistryIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/studio': typeof AppStudioIndexRoute
  '/tasks': typeof AppTasksIndexRoute
  '/registry/agents/$name': typeof AppRegistryAgentsNameRoute
  '/x/$pluginId/$': typeof AppXPluginIdSplatRoute
  '/studio/bundles/$bundleId/versions/$version/publish': typeof AppStudioBundlesBundleIdVersionsVersionPublishRoute
  '/studio/bundles/$bundleId/versions/$version': typeof AppStudioBundlesBundleIdVersionsVersionIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/external': typeof ExternalRoute
  '/login': typeof LoginRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/knowledge': typeof AppKnowledgeRoute
  '/_app/modules': typeof AppModulesRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/studio': typeof AppStudioRouteWithChildren
  '/_app/users': typeof AppUsersRoute
  '/_app/': typeof AppIndexRoute
  '/_app/approval-requests/$requestId': typeof AppApprovalRequestsRequestIdRoute
  '/_app/approvals/$approvalId': typeof AppApprovalsApprovalIdRoute
  '/_app/cases/$caseId': typeof AppCasesCaseIdRoute
  '/_app/settings/models': typeof AppSettingsModelsRoute
  '/_app/studio/new': typeof AppStudioNewRoute
  '/_app/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/_app/approvals/': typeof AppApprovalsIndexRoute
  '/_app/cases/': typeof AppCasesIndexRoute
  '/_app/registry/': typeof AppRegistryIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/studio/': typeof AppStudioIndexRoute
  '/_app/tasks/': typeof AppTasksIndexRoute
  '/_app/registry/agents/$name': typeof AppRegistryAgentsNameRoute
  '/_app/x/$pluginId/$': typeof AppXPluginIdSplatRoute
  '/_app/studio/bundles/$bundleId/versions/$version/publish': typeof AppStudioBundlesBundleIdVersionsVersionPublishRoute
  '/_app/studio/bundles/$bundleId/versions/$version/': typeof AppStudioBundlesBundleIdVersionsVersionIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/external'
    | '/login'
    | '/admin'
    | '/knowledge'
    | '/modules'
    | '/settings'
    | '/studio'
    | '/users'
    | '/approval-requests/$requestId'
    | '/approvals/$approvalId'
    | '/cases/$caseId'
    | '/settings/models'
    | '/studio/new'
    | '/tasks/$taskId'
    | '/approvals/'
    | '/cases/'
    | '/registry/'
    | '/settings/'
    | '/studio/'
    | '/tasks/'
    | '/registry/agents/$name'
    | '/x/$pluginId/$'
    | '/studio/bundles/$bundleId/versions/$version/publish'
    | '/studio/bundles/$bundleId/versions/$version/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/external'
    | '/login'
    | '/admin'
    | '/knowledge'
    | '/modules'
    | '/users'
    | '/'
    | '/approval-requests/$requestId'
    | '/approvals/$approvalId'
    | '/cases/$caseId'
    | '/settings/models'
    | '/studio/new'
    | '/tasks/$taskId'
    | '/approvals'
    | '/cases'
    | '/registry'
    | '/settings'
    | '/studio'
    | '/tasks'
    | '/registry/agents/$name'
    | '/x/$pluginId/$'
    | '/studio/bundles/$bundleId/versions/$version/publish'
    | '/studio/bundles/$bundleId/versions/$version'
  id:
    | '__root__'
    | '/_app'
    | '/external'
    | '/login'
    | '/_app/admin'
    | '/_app/knowledge'
    | '/_app/modules'
    | '/_app/settings'
    | '/_app/studio'
    | '/_app/users'
    | '/_app/'
    | '/_app/approval-requests/$requestId'
    | '/_app/approvals/$approvalId'
    | '/_app/cases/$caseId'
    | '/_app/settings/models'
    | '/_app/studio/new'
    | '/_app/tasks/$taskId'
    | '/_app/approvals/'
    | '/_app/cases/'
    | '/_app/registry/'
    | '/_app/settings/'
    | '/_app/studio/'
    | '/_app/tasks/'
    | '/_app/registry/agents/$name'
    | '/_app/x/$pluginId/$'
    | '/_app/studio/bundles/$bundleId/versions/$version/publish'
    | '/_app/studio/bundles/$bundleId/versions/$version/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ExternalRoute: typeof ExternalRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/external': {
      id: '/external'
      path: '/external'
      fullPath: '/external'
      preLoaderRoute: typeof ExternalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/knowledge': {
      id: '/_app/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof AppKnowledgeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/modules': {
      id: '/_app/modules'
      path: '/modules'
      fullPath: '/modules'
      preLoaderRoute: typeof AppModulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/studio': {
      id: '/_app/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof AppStudioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approval-requests/$requestId': {
      id: '/_app/approval-requests/$requestId'
      path: '/approval-requests/$requestId'
      fullPath: '/approval-requests/$requestId'
      preLoaderRoute: typeof AppApprovalRequestsRequestIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals/': {
      id: '/_app/approvals/'
      path: '/approvals'
      fullPath: '/approvals/'
      preLoaderRoute: typeof AppApprovalsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals/$approvalId': {
      id: '/_app/approvals/$approvalId'
      path: '/approvals/$approvalId'
      fullPath: '/approvals/$approvalId'
      preLoaderRoute: typeof AppApprovalsApprovalIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cases/': {
      id: '/_app/cases/'
      path: '/cases'
      fullPath: '/cases/'
      preLoaderRoute: typeof AppCasesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cases/$caseId': {
      id: '/_app/cases/$caseId'
      path: '/cases/$caseId'
      fullPath: '/cases/$caseId'
      preLoaderRoute: typeof AppCasesCaseIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/registry/': {
      id: '/_app/registry/'
      path: '/registry'
      fullPath: '/registry/'
      preLoaderRoute: typeof AppRegistryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/models': {
      id: '/_app/settings/models'
      path: '/models'
      fullPath: '/settings/models'
      preLoaderRoute: typeof AppSettingsModelsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/studio/': {
      id: '/_app/studio/'
      path: '/'
      fullPath: '/studio/'
      preLoaderRoute: typeof AppStudioIndexRouteImport
      parentRoute: typeof AppStudioRoute
    }
    '/_app/studio/new': {
      id: '/_app/studio/new'
      path: '/new'
      fullPath: '/studio/new'
      preLoaderRoute: typeof AppStudioNewRouteImport
      parentRoute: typeof AppStudioRoute
    }
    '/_app/tasks/': {
      id: '/_app/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AppTasksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks/$taskId': {
      id: '/_app/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof AppTasksTaskIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/registry/agents/$name': {
      id: '/_app/registry/agents/$name'
      path: '/registry/agents/$name'
      fullPath: '/registry/agents/$name'
      preLoaderRoute: typeof AppRegistryAgentsNameRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/x/$pluginId/$': {
      id: '/_app/x/$pluginId/$'
      path: '/x/$pluginId/$'
      fullPath: '/x/$pluginId/$'
      preLoaderRoute: typeof AppXPluginIdSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/studio/bundles/$bundleId/versions/$version/': {
      id: '/_app/studio/bundles/$bundleId/versions/$version/'
      path: '/bundles/$bundleId/versions/$version'
      fullPath: '/studio/bundles/$bundleId/versions/$version/'
      preLoaderRoute: typeof AppStudioBundlesBundleIdVersionsVersionIndexRouteImport
      parentRoute: typeof AppStudioRoute
    }
    '/_app/studio/bundles/$bundleId/versions/$version/publish': {
      id: '/_app/studio/bundles/$bundleId/versions/$version/publish'
      path: '/bundles/$bundleId/versions/$version/publish'
      fullPath: '/studio/bundles/$bundleId/versions/$version/publish'
      preLoaderRoute: typeof AppStudioBundlesBundleIdVersionsVersionPublishRouteImport
      parentRoute: typeof AppStudioRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsModelsRoute: typeof AppSettingsModelsRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsModelsRoute: AppSettingsModelsRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppStudioRouteChildren {
  AppStudioNewRoute: typeof AppStudioNewRoute
  AppStudioIndexRoute: typeof AppStudioIndexRoute
  AppStudioBundlesBundleIdVersionsVersionPublishRoute: typeof AppStudioBundlesBundleIdVersionsVersionPublishRoute
  AppStudioBundlesBundleIdVersionsVersionIndexRoute: typeof AppStudioBundlesBundleIdVersionsVersionIndexRoute
}

const AppStudioRouteChildren: AppStudioRouteChildren = {
  AppStudioNewRoute: AppStudioNewRoute,
  AppStudioIndexRoute: AppStudioIndexRoute,
  AppStudioBundlesBundleIdVersionsVersionPublishRoute:
    AppStudioBundlesBundleIdVersionsVersionPublishRoute,
  AppStudioBundlesBundleIdVersionsVersionIndexRoute:
    AppStudioBundlesBundleIdVersionsVersionIndexRoute,
}

const AppStudioRouteWithChildren = AppStudioRoute._addFileChildren(
  AppStudioRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRoute
  AppKnowledgeRoute: typeof AppKnowledgeRoute
  AppModulesRoute: typeof AppModulesRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppStudioRoute: typeof AppStudioRouteWithChildren
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppApprovalRequestsRequestIdRoute: typeof AppApprovalRequestsRequestIdRoute
  AppApprovalsApprovalIdRoute: typeof AppApprovalsApprovalIdRoute
  AppCasesCaseIdRoute: typeof AppCasesCaseIdRoute
  AppTasksTaskIdRoute: typeof AppTasksTaskIdRoute
  AppApprovalsIndexRoute: typeof AppApprovalsIndexRoute
  AppCasesIndexRoute: typeof AppCasesIndexRoute
  AppRegistryIndexRoute: typeof AppRegistryIndexRoute
  AppTasksIndexRoute: typeof AppTasksIndexRoute
  AppRegistryAgentsNameRoute: typeof AppRegistryAgentsNameRoute
  AppXPluginIdSplatRoute: typeof AppXPluginIdSplatRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRoute,
  AppKnowledgeRoute: AppKnowledgeRoute,
  AppModulesRoute: AppModulesRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppStudioRoute: AppStudioRouteWithChildren,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppApprovalRequestsRequestIdRoute: AppApprovalRequestsRequestIdRoute,
  AppApprovalsApprovalIdRoute: AppApprovalsApprovalIdRoute,
  AppCasesCaseIdRoute: AppCasesCaseIdRoute,
  AppTasksTaskIdRoute: AppTasksTaskIdRoute,
  AppApprovalsIndexRoute: AppApprovalsIndexRoute,
  AppCasesIndexRoute: AppCasesIndexRoute,
  AppRegistryIndexRoute: AppRegistryIndexRoute,
  AppTasksIndexRoute: AppTasksIndexRoute,
  AppRegistryAgentsNameRoute: AppRegistryAgentsNameRoute,
  AppXPluginIdSplatRoute: AppXPluginIdSplatRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ExternalRoute: ExternalRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
